export const setIntoLocalStorage = (key: string, value: any) =>
  localStorage.setItem(key, value);

export const getFromLocalStorage = (key: string) => localStorage.getItem(key);
